class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this), { passive: true });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape, { passive: true });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange, { passive: true });
  }

  static toggleActiveFacets(disable = true) {
    // document.querySelectorAll('.js-facet-remove').forEach((element) => {
    //   element.classList.toggle('disabled', disable);
    // });

    document.querySelectorAll(".ml_filter").forEach((el) => {
      const length = el.querySelectorAll(".ml_filter_body.expand")?.length > 0;
      if (length) {
        el.querySelector(".ml_filter_header")?.querySelector("svg")?.classList.add("expand_icon");
      }
    })

  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
      
      const toggleFilter = document.getElementById("Filter_Mobile_btn");
      toggleFilter?.click();
    } 
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    const target = document.getElementById('ProductGridContainer');
    if (parsed && target) target.innerHTML = parsed.innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      if (count != null) container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      if (count != null) containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      if (document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`))
        document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector(".ml_price_slider_wrap");
    const minField =
      this.querySelector('[data-handle="min"]') || this.querySelector("#MLPriceMin");
    const maxField =
      this.querySelector('[data-handle="max"]') || this.querySelector("#MLPriceMax");
    this.inputs = {
      min: minField?.querySelector("input"),
      max: maxField?.querySelector("input"),
    };
    this.handles = {
      min: minField?.querySelector(".ml_price_handle, label"),
      max: maxField?.querySelector(".ml_price_handle, label"),
    };
    this.valueLabels = {
      min: this.querySelector(".ml_price_value_min"),
      max: this.querySelector(".ml_price_value_max"),
    };
    this.moneyTemplate = this.dataset.money || "";
    this.currencyCode = this.dataset.currency || "USD";
    try {
      this.formatter = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: this.currencyCode,
        maximumFractionDigits: 0,
      });
    } catch (_) {
      this.formatter = null;
    }

    this.dragData = {
      min: { drag: false, pos: 0, start: 0 },
      max: { drag: false, pos: 0, start: 0 },
    };

    this.querySelectorAll("input")
      .forEach((el) => el.addEventListener("change", this.onRangeChange.bind(this), { passive: true }));

    const supportsPointer = "PointerEvent" in window;

    ["min", "max"].forEach((type) => {
      const h = this.handles[type];
      if (!h) return;
      if (supportsPointer) {
        h.addEventListener("pointerdown", (e) => this.handleStartDrag(type, e));
      } else {
        h.addEventListener("mousedown", (e) => this.handleStartDrag(type, e));
        h.addEventListener("touchstart", (e) => this.handleStartDrag(type, e), { passive: true });
      }
    });

    if (supportsPointer) {
      document.addEventListener("pointermove", this.handleDrag.bind(this));
      document.addEventListener("pointerup", this.handleStopDrag.bind(this, null));
      document.addEventListener("pointercancel", this.handleStopDrag.bind(this, null));
    } else {
      document.addEventListener("mousemove", this.handleDrag.bind(this));
      document.addEventListener("mouseup", this.handleStopDrag.bind(this, null));
      document.addEventListener("touchmove", this.handleDrag.bind(this), { passive: true });
      document.addEventListener("touchend", this.handleStopDrag.bind(this, null));
    }

    this.setMinAndMaxValues();
    this.handleDefaultCase();

    window.addEventListener("resize", () => {
      this.handleDefaultCase();
    }, { passive: true });
  }

  trackWidth() {
    return (this.slider?.clientWidth || this.clientWidth || 1);
  }

  positionHandleFromValue(type) {
    const max = +(this.dataset.max || "0") || 1;
    const input = this.inputs[type];
    const handle = this.handles[type];
    if (!input || !handle) return;
    const v = +(input.value || (type === "max" ? max : 0));
    const width = this.trackWidth();
    const left = Math.max(0, Math.min(width, (v / max) * width));
    handle.style.left = `${left}px`;
  }

  handleDefaultCase() {
    this.positionHandleFromValue("min");
    this.positionHandleFromValue("max");
    this.updateFill();
    const max = +(this.dataset.max || "0") || 0;
    const minV = +(this.inputs.min?.value || 0);
    const maxV = +(this.inputs.max?.value || max);
    this.updateValueLabel("min", minV);
    this.updateValueLabel("max", maxV);
  }

  updateFill() {
    const width = this.trackWidth();
    const minLeft = parseFloat(this.handles.min?.style.left) || 0;
    const maxLeft = parseFloat(this.handles.max?.style.left) || width;
    const left = Math.max(0, Math.min(minLeft, maxLeft));
    const right = Math.max(minLeft, maxLeft);
    this.style.setProperty("--ml-fill-left", `${left}px`);
    this.style.setProperty("--ml-fill-width", `${Math.max(0, right - left)}px`);
  }

  pointerX(event) {
    if (event.clientX != null && event.pageX == null) return event.clientX;
    if (event.touches && event.touches[0]) return event.touches[0].pageX;
    if (event.changedTouches && event.changedTouches[0]) return event.changedTouches[0].pageX;
    return event.pageX != null ? event.pageX : event.x;
  }

  handleStartDrag(type, event) {
    this.dragData[type].drag = true;
    this.dragData[type].start = this.pointerX(event);
    this.dragData[type].pos = this.handles[type]?.offsetLeft || 0;
    document.getElementById("Filter_Container")?.classList.add("dragging");
    document.getElementById("ghcDrawer")?.classList.add("dragging");
    this.classList.add("dragging");
    if (event.pointerId != null && this.handles[type]?.setPointerCapture) {
      try { this.handles[type].setPointerCapture(event.pointerId); } catch (_) {}
    }
    if (event.cancelable && event.preventDefault) event.preventDefault();
  }

  handleDrag(event) {
    const type = this.dragData.min.drag ? "min" : (this.dragData.max.drag ? "max" : null);
    if (!type) return;
    this.handleMove(type, event);
  }

  handleMove(type, event) {
    const handle = this.handles[type];
    if (!handle) return;
    const x = this.pointerX(event);
    const delta = x - this.dragData[type].start;
    this.dragData[type].start = x;
    const width = this.trackWidth();
    let total = (parseFloat(handle.style.left) || (type === "min" ? 0 : width)) + delta;
    const minBound = type === "min" ? 0 : (parseFloat(this.handles.min?.style.left) || 0) + 12;
    const maxBound = type === "min" ? (parseFloat(this.handles.max?.style.left) || width) - 12 : width;
    if (total < minBound) total = minBound;
    if (total > maxBound) total = maxBound;
    handle.style.left = `${total}px`;
    this.handlePriceChange(type);
    this.updateFill();
  }

  handleStopDrag(type, event) {
    if (!type) {
      if (this.dragData.min.drag) type = "min";
      else if (this.dragData.max.drag) type = "max";
      else return;
    }
    if (!this.dragData[type].drag) return;
    this.dragData[type].drag = false;
    document.getElementById("Filter_Container")?.classList.remove("dragging");
    document.getElementById("ghcDrawer")?.classList.remove("dragging");
    this.classList.remove("dragging");
    if (this.inputs[type]) this.handleFilterApply(this.inputs[type]);
  }

  handleFilterApply(item) {
    // Make sure the input has its native attribute reflect the new value so FormData picks it up
    if (item.value !== undefined) item.setAttribute("value", item.value);
    item.dispatchEvent(new Event("change", { bubbles: true }));
    const form = item.closest("form") || document.getElementById("FacetFiltersForm");
    if (form) form.dispatchEvent(new Event("input", { bubbles: true }));
  }

  handlePriceChange(type) {
    const input = this.inputs[type];
    const handle = this.handles[type];
    if (!input || !handle) return;
    const max = +(this.dataset.max || "1") || 1;
    const offset = parseFloat(handle.style.left) || handle.offsetLeft || 0;
    const ratio = offset / this.trackWidth();
    const value = Math.round(ratio * max);
    input.value = value;
    input.setAttribute("value", value);
    this.updateValueLabel(type, value);
  }

  updateValueLabel(type, value) {
    const label = this.valueLabels?.[type];
    if (!label) return;
    const num = Number(value) || 0;
    if (this.formatter) {
      label.textContent = this.formatter.format(num);
    } else if (this.moneyTemplate) {
      label.textContent = this.moneyTemplate.replace(/0\.00|0,00|0/, num);
    } else {
      label.textContent = num;
    }
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget || event.target);
    this.setMinAndMaxValues();
    this.positionHandleFromValue("min");
    this.positionHandleFromValue("max");
    this.updateFill();
  }

  setMinAndMaxValues() {
    const minInput = this.inputs.min;
    const maxInput = this.inputs.max;
    if (!minInput || !maxInput) return;
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);
